import { useEffect, useState } from 'react'

export function useResponsiveSize() {
    const [vw, setVw] = useState(Math.max(document.documentElement.clientWidth, window.innerWidth))
    const [vh, setVh] = useState(
        Math.max(document.documentElement.clientHeight, window.innerHeight)
    )

    useEffect(() => {
        const handleResize = () => {
            setVw(Math.max(document.documentElement.clientWidth, window.innerWidth))
            setVh(Math.max(document.documentElement.clientHeight, window.innerHeight))
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return { vw, vh }
}
